import React from "react";
import { FormattedMessage } from "react-intl";
import PropTypes from "prop-types";
import { fontSize } from "style";
import { css } from "@emotion/react";

/**
 * InterviewTitle
 *
 * @param {String} titleId
 * @param {String} label
 */
const InterviewTitle = ({ label, titleId, ...props }) => (
  <>
    {label && <div css={styles.label}>{label}</div>}
    <h1 css={styles.page_title}>
      <FormattedMessage id={titleId} {...props} />
    </h1>
  </>
);

const styles = {
  page_title: css`
    font-size: ${fontSize.xxlarge};
    font-weight: 800;
  `,
  label: css`
    font-size: ${fontSize.large};
    font-weight: 600;
  `,
};

InterviewTitle.propTypes = {
  titleId: PropTypes.string.isRequired,
  label: PropTypes.string,
};

export default InterviewTitle;
